(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["estimated-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
if (window.__miaEtaInit) return;
window.__miaEtaInit = true;
/* Recalculate the window from the visitor's own date, so it is always based on today. */
function refresh(root) {
var nodes = (root || document).querySelectorAll('[data-mia-eta][data-min-days]');
for (var i = 0; i < nodes.length; i++) {
var el = nodes[i];
var out = el.querySelector('[data-mia-eta-dates]');
var min = parseInt(el.getAttribute('data-min-days'), 10);
var max = parseInt(el.getAttribute('data-max-days'), 10);
if (!out || isNaN(min) || isNaN(max)) continue;
try {
var today = new Date();
var from = new Date(today.getFullYear(), today.getMonth(), today.getDate() + min);
var to = new Date(today.getFullYear(), today.getMonth(), today.getDate() + max);
var fmt = new Intl.DateTimeFormat(el.getAttribute('data-locale') || 'en', { month: 'long', day: 'numeric' });
var text = typeof fmt.formatRange === 'function' ? fmt.formatRange(from, to) : null;
if (text && out.textContent !== text) out.textContent = text;
} catch (e) {
/* keep the server-rendered dates */
}
}
}
/* "Shipping information": open the matching accordion row of the same product section. */
document.addEventListener('click', function (event) {
var link = event.target.closest ? event.target.closest('[data-mia-eta-link]') : null;
if (!link) return;
var wanted = (link.getAttribute('data-target-heading') || '').trim().toLowerCase();
var scope = link.closest('.shopify-section') || document;
var rows = scope.querySelectorAll('details');
var match = null;
for (var i = 0; i < rows.length; i++) {
var summary = rows[i].querySelector('summary');
if (summary && wanted && summary.textContent.trim().toLowerCase().indexOf(wanted) !== -1) {
match = rows[i];
break;
}
}
if (!match) return;
event.preventDefault();
match.open = true;
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
match.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
});
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () {
refresh();
});
} else {
refresh();
}
document.addEventListener('shopify:section:load', function (event) {
refresh(event.target);
});
})();
  } catch(e) { console.error(e); }
})();

})();
